/*!
 * Copyright © 2020. Verizon Connect Ireland Limited. All rights reserved.
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PendoModule } from '@fleetmatics/ui.insights';

import { environment } from '../../environments/environment';
import { ExternalContainerComponent } from './components';
import { LiveChatScriptLoaderService, PendoTrackEventService, WebsocketConnectorService, WebsocketScriptsLoaderService } from './services';

@NgModule({
  declarations: [ExternalContainerComponent],
  imports: [CommonModule, PendoModule.forRoot(environment.config)],
  providers: [WebsocketScriptsLoaderService, WebsocketConnectorService, PendoTrackEventService, LiveChatScriptLoaderService],
  bootstrap: [ExternalContainerComponent]
})
export class ExternalModule {}
